module.exports = __webpack_public_path__ + "static/media/personal-loan 2.71db0392.jpg";